import React, {useState, useEffect} from 'react';
import {useRouter} from 'next/router';
import styled from "styled-components";
import AppLayout from "@layouts/app.layout";
import {getCityByName, getCityURL, getDistricts} from "@models/district";
import {getAreasByDistrictIdForAreaType, getNorthCitiesIds} from "@models/area";
import {getUrlDealTypes, getUrlTypes} from "@models/property";
import Navbar from "@organisms/navbar/navbar";
import {handleFooterLinks} from "@organisms/footer/helpers";
import {handleNavbarLinks} from "@organisms/navbar/helpers";
import {generateSearchUrl} from "@organisms/property/helpers/search_helper";
import SiteMapMainLinks from "@organisms/sitemap/main_links";
import SiteMapDistricts from "@organisms/sitemap/districts";
import SiteMapAreas from "@organisms/sitemap/areas";
import SiteMapSkeleton from "@organisms/sitemap/skeleton";
import {isEmpty, str_replace} from "@helpers/helpers";
import {inArray, is_array} from "@helpers/arrays";
import {getDefaultCity} from "../../../components/hooks/cities";


const ShowSiteMap = ({ssrCity, ssrDistricts, ssrAreas, ssrRegions, ssrNorthCitiesIds, navbarLinks, footerLinks, defaultCityId}) => {
    const router = useRouter();
    const [cityState, setCity] = useState(null);
    const [districtsState, setDistricts] = useState([]);
    const [areasState, setAreas] = useState([]);
    const [regionsState, setRegions] = useState([]);
    const [northCitiesIdsState, setNorthCitiesIds] = useState([]);

    const golbaharId = 262;

    useEffect(() => {
        let getDistricts = true;
        let selectedCity = null;

        if (isEmpty(cityState)) {
            if (!isEmpty(ssrCity)) {
                setCity(ssrCity);
                selectedCity = ssrCity;
            } else {
                if (router && router.query && router.query.cityName) {
                    const cityName = router.query.cityName;

                    getCityByName(cityName).then(city => {
                        if (city) {
                            setCity(city);
                            getDistricts = false;

                            handleDistricts(city.id);
                            handleAreas(city.id);
                            handleRegions(city.id);
                        }
                    })
                }
            }
        }

        if (!districtsState.length && getDistricts) {
            if (!isEmpty(ssrDistricts) && ssrDistricts.length) {
                setDistricts(ssrDistricts);
            } else if (!isEmpty(selectedCity)) {
                handleDistricts(selectedCity.id);
            }
        }

        if (!areasState.length && getDistricts) {
            if (!isEmpty(ssrAreas) && ssrAreas.length) {
                setAreas(ssrAreas);
            } else if (!isEmpty(selectedCity)) {
                handleAreas(selectedCity.id);
            }
        }

        if (!regionsState.length && getDistricts) {
            if (!isEmpty(ssrRegions) && ssrRegions.length) {
                setAreas(ssrRegions);
            } else if (!isEmpty(selectedCity)) {
                handleRegions(selectedCity.id);
            }
        }

        if (!northCitiesIdsState.length) {
            if (!isEmpty(ssrNorthCitiesIds) && ssrNorthCitiesIds.length) {
                setNorthCitiesIds(ssrNorthCitiesIds);
            } else {
                getNorthCitiesIds().then(ids => {
                    setNorthCitiesIds(ids);
                })
            }
        }
    }, []);

    const handleDistricts = (city_id) => {
        getDistricts(city_id).then(result => {
            if (result && result.districts) {
                setDistricts(result.districts);
            }
        })
    };

    const handleAreas = (city_id) => {
        getAreasByDistrictIdForAreaType(city_id, 'district').then(result => {
            if (result && result.areas) {
                setAreas(result.areas);
            }
        })
    };

    const handleRegions = (city_id) => {
        getAreasByDistrictIdForAreaType(city_id, 'region').then(result => {
            if (result && result.areas) {
                setRegions(result.areas);
            }
        })
    };

    const handleUrl = (city_name, deal_type, type, district_name = null) => {
        let link = getCityURL(city_name);

        if (!isEmpty(deal_type) && !isEmpty(type)) {
            const dealTypeUrl = getUrlDealTypes(deal_type);
            const typeUrl = getUrlTypes(type);

            link = generateSearchUrl(city_name, typeUrl, dealTypeUrl, district_name)
        }

        return link;
    };

    const handleAreaUrl = (city_name) => {
        return '/محله/' + str_replace(' ', '-', city_name);
    };

    let districtSections = [
        {deal_type: 'sale', type: 'apartment'},
        {deal_type: 'rent', type: 'apartment'},
    ];

    const city = (!isEmpty(ssrCity)) ? ssrCity : cityState;
    const districts = (!isEmpty(ssrDistricts) && is_array(ssrDistricts) && ssrDistricts.length) ? ssrDistricts : districtsState;
    const areas = (!isEmpty(ssrAreas) && is_array(ssrAreas) && ssrAreas.length) ? ssrAreas : areasState;
    const regions = (!isEmpty(ssrRegions) && is_array(ssrRegions) && ssrRegions.length) ? ssrRegions : regionsState;
    const northCitiesIds = (!isEmpty(ssrNorthCitiesIds) && ssrNorthCitiesIds.length) ? ssrNorthCitiesIds : northCitiesIdsState;
    const isNorthCity = (!isEmpty(city) && inArray(city.id, northCitiesIds));
    if (isNorthCity) {
        districtSections = [
            {deal_type: 'sale', type: 'villa'},
            {deal_type: 'sale', type: 'land'},
        ];
    }

    return (
        <AppLayout
            footerLinks={footerLinks}
            pageRobots="index, follow, NOODP"
            pageTitle={'نقشه سایت | ' + (!isEmpty(city) ? city.name : '')}
            pageDescription={(!isEmpty(city) ? city.name : '')}
            investment={false}
            selectedCityId={defaultCityId}
        >
            <Navbar
                navbarLinks={navbarLinks}
                selectedCityId={defaultCityId}
            />

            {
                (!isEmpty(city)) ?
                    <Container className="container mt-56">
                        <h1 className="h1-bold">{city.name}</h1>

                        <SiteMapMainLinks
                            handleUrl={handleUrl}
                            city={city}
                            handleAreaUrl={handleAreaUrl}
                            hasArea={(areas.length)}
                            isGolbahar={(city.id === golbaharId)}
                        />

                        {
                            districtSections.map((section, key) => {
                                return (
                                    <React.Fragment>
                                        <PageDivider/>

                                        {
                                            (districts.length) ?
                                                <SiteMapDistricts
                                                    section={section}
                                                    handleUrl={handleUrl}
                                                    city={city}
                                                    districts={districts}
                                                />
                                                :
                                                <SiteMapSkeleton titleHeight={32} withoutContainer={true}/>
                                        }
                                    </React.Fragment>
                                )
                            })
                        }

                        {
                            (areas.length) ?
                                <React.Fragment>
                                    <PageDivider/>

                                    <SiteMapAreas
                                        city={city}
                                        regions={regions}
                                        areas={areas}
                                    />
                                </React.Fragment>
                                : ''
                        }

                    </Container>
                    :
                    <SiteMapSkeleton/>
            }
        </AppLayout>
    );
};

ShowSiteMap.getInitialProps = async (context) => {
    const {req} = context;
    let defaultCityId = 259;

    if (req && req.cookies && !isEmpty(req.cookies['default_city_id'])) {
        defaultCityId = req.cookies['default_city_id'];
    } else if (process.browser) {
        defaultCityId = getDefaultCity();
    }

    let footerLinks = null;
    let navbarLinks = null;
    let city = null;
    let districts = null;
    let areas = null;
    let regions = null;
    let northCitiesIds = null;

    if (!process.browser) {
        if (!isEmpty(req) && !isEmpty(req.params) && !isEmpty(req.params.cityName)) {
            const cityName = req.params.cityName;

            city = await getCityByName(str_replace('-', ' ', cityName))
        }

        if (!isEmpty(city)) {
            districts = await getDistricts(city.id);
            areas = await getAreasByDistrictIdForAreaType(city.id, 'district');
            regions = await getAreasByDistrictIdForAreaType(city.id, 'region')
        }

        footerLinks = await handleFooterLinks(defaultCityId);
        navbarLinks = await handleNavbarLinks(defaultCityId);

        northCitiesIds = await getNorthCitiesIds();
    }


    return {
        ssrCity: city,
        ssrDistricts: !isEmpty(districts) ? districts.districts : [],
        ssrAreas: !isEmpty(areas) ? areas.areas : [],
        ssrRegions: !isEmpty(regions) ? regions.areas : [],
        ssrNorthCitiesIds: northCitiesIds,
        navbarLinks: navbarLinks,
        footerLinks: footerLinks,
        defaultCityId: defaultCityId
    }
};

export default ShowSiteMap;

// styles

const Container = styled.div`
    padding-bottom: 132px;
    
    .items-link {
        &:hover {
            color: ${props => props.theme.secondary};
            
            svg {
                path {
                    stroke: ${props => props.theme.secondary};;
                }
            }
        }
    }
`;

const PageDivider = styled.div`
    margin: 64px 0;
    border-top: 1px solid ${props => props.theme.gray200};
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        margin: 40px 0;
    }
`;